import SLMLeaseList from "containers/slm/SLMLeaseList";
import React, { Component } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import "react-table/react-table.css";
import { API } from "aws-amplify";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
import { PacmanLoader } from "react-spinners";

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class SLMLeasesSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searching: false,
      stateOptions: [],
      selectedState: null,
      leases: [],

      selectedSpaceUseCategories: null,
      selectedBroadSpaceUseCategories: null,
      selectedLeaseMethodCategories: null,
      selectedClientExport: null,
      clientExports: [{ value: "CBRE", label: "CBRE leases" }], //,{value: "NAB", label: "Valex/NAB"},{vale: "CL", label: "CL Research"}, {value: "GAP", label: "Gap Maps"}, {value: "ONE", label: "One Map"}],
      cbreHeaderRow: ["UniquePIMLeaseID,Leaseid,hardSequence,addresshardSequence,leaseSource1,sourceDate1,sourcePage1,leaseSource2,sourceDate2,sourcePage2,leaseSource3,sourceDate3,sourcePage3,printMonth,prevDelivery,buildingName,streetAddress,addressSuburb,addressState,addressPC,floorUnit,streetNoLow,streetNoHigh,streetName,extenstion,leaseStatus,leaseSpaceUse,leaseBroadSpaceUse,leaseCommenceDate,IsLeased,leaseType,leaseQualityType,rentPerAnnum,rentPerAnnumBasis,rentPerSQM,rentPerSQMBasis,estimated,outgoings,tenantArea,leaseLevelDescr,leaseLevel,term,options,review,leaseReviewBasis,leaseOutgoingsBasis,cars,carRate,lessee,owner,agent,agency,editorsNote,statDate,pending,noteData"],
      createdby: null,
      editedby: null,
      printdatefrom: null,
      printdateto: null,
      statdatefrom: null,
      statdateto: null,
      rentpsqmfrom: null,
      rentpsqmto: null,
      rentpannumfrom: null,
      rentpannumto: null,
      broadspace: null,
      spaceuse: null,
      leasemethod: null,
      buildingname: null,
      streetname: null,
      suburb: null,
      postcode: null,
      state: null,
      agent: null,
      agency: null,
      lessee: null,
      lessor: null,
      leasetype: null,
      isLoading: true,

      search_count: 0,
      filter: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.exportRecords = this.exportRecords.bind(this);
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      // if false
      return;
    }

    this.getStates({});
    document.title = "SLM Leases Search";
    this.setState({ isLoading: false });
  }

  getLeases(filter) {
    console.log("Inside getaddresses()");

    console.log(filter);

    //  this.setState({ searching : true });

    return API.get("colin", "/slmleases", { queryStringParameters: filter });
  }

  getLeasesExport(filter) {
    console.log("Inside getLeasesExport()");

    console.log(filter);

    //  this.setState({ searching : true });

    return API.get("colin", "/slmleasesexport", { queryStringParameters: filter });
  }

  getLeasesClientExport(filter) {
    console.log("Inside getLeasesClientExport()");

    console.log(filter);

    //  this.setState({ searching : true });

    return API.get("colin", "/slmleasesclientexport", { queryStringParameters: filter });
  }

  getStates() {
    try {
      API.get("colin", `/slmstates`, { cancelToken: source.token }).then((stateOptions) => {
        if (stateOptions) {
          this.setState((state) => ({ stateOptions }));
        }
      });
    } catch {
      console.log("Error getting states");
    }
  }

  handleChange = (event) => {
    console.log("Inside handleChange");
    this.setState({
      [event.target.id]: event.target.value,
    });
  };
  handlePercentChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleNumberChange = (event) => {
    let val = event.target.value.replace(/[^0-9.]/g, "");
    this.setState({
      [event.target.id]: val,
    });
    this.setState({ modified: true });
  };

  handleDateChange(date, name) {
    if (date) {
      this.setState({
        [name]: new Date(date),
      });
    } else {
      this.setState({
        [name]: null,
      });
    }
    this.setState({ modified: true });
  }

  handleStateChange = (selectedState) => {
    if (selectedState) {
      this.setState({ selectedState });
      this.setState({ state: selectedState.value });
    } else {
      this.setState({ selectedState: { value: null, label: null } });
      this.setState({ state: null });
    }

    this.setState({ modified: true });
  };

  handleBroadSpaceUseChange = async (selectedBroadSpaceUseCategories) => {
    if (selectedBroadSpaceUseCategories) {
      this.setState({ selectedBroadSpaceUseCategories, broadspace: selectedBroadSpaceUseCategories.value, modified: true, selectedSpaceUseCategories: { value: null, label: null }, space_use_id: null });
    } else {
      this.setState({ selectedBroadSpaceUseCategories: { value: null, label: null }, broadspace: null, modified: true, selectedSpaceUseCategories: { value: null, label: null }, spaceuse: null });
    }
  };

  handleSpaceUseChange = (selectedSpaceUseCategories) => {
    if (selectedSpaceUseCategories) {
      this.setState({ selectedSpaceUseCategories, spaceuse: selectedSpaceUseCategories.value, broadspace: selectedSpaceUseCategories.supplementary_details.broad_space_use_id, modified: true, selectedBroadSpaceUseCategories: { value: selectedSpaceUseCategories.supplementary_details.broad_space_use_id, label: selectedSpaceUseCategories.supplementary_details.broad_space_use_code } });
    } else {
      this.setState({ selectedSpaceUseCategories: { value: null, label: null }, spaceuse: null, modified: true });
    }
  };

  handleClientExportChange = (selectedClientExport) => {
    if (selectedClientExport) {
      this.setState({ selectedClientExport });
    } else {
      this.setState({ selectedClientExport: { value: null, label: null } });
    }
  };

  selectedLeaseMethodCategories = (selectedLeaseMethodCategories) => {
    if (selectedLeaseMethodCategories) {
      this.props.saleTypes.filter((a) => {
        if (a.value === selectedLeaseMethodCategories.value) {
          return true;
        } else {
          return false;
        }
      });

      this.setState({ selectedLeaseMethodCategories, leasemethod: selectedLeaseMethodCategories.value, modified: true });
    } else {
      this.setState({ selectedLeaseMethodCategories: { value: null, label: null }, leasemethod: null, modified: true });
    }
  };

  async handleSubmit(event) {
    console.log("HandleSubmit");
    event.preventDefault();
    this.setState({ isLoading: true });
    console.log(this.state.statdatefrom);
    try {
      const leases = await this.getLeases({
        createdby: this.state.createdby,
        editedby: this.state.editedby,
        printdatefrom: this.state.printdatefrom !== null ? Moment(this.state.printdatefrom).local().format() : "",
        printdateto: this.state.printdateto !== null ? Moment(this.state.printdateto).local().format() : "",
        statdatefrom: this.state.statdatefrom !== null ? Moment(this.state.statdatefrom).local().format() : "",
        statdateto: this.state.statdateto !== null ? Moment(this.state.statdateto).local().format() : "",
        rentpsqmfrom: this.state.rentpsqmfrom,
        rentpsqmto: this.state.rentpsqmto,
        rentpannumfrom: this.state.rentpannumfrom,
        rentpannumto: this.state.rentpannumto,
        broadspace: this.state.broadspace,
        spaceuse: this.state.spaceuse,
        titlebasis: this.state.titlebasis,
        leasemethod: this.state.leasemethod,
        buildingname: this.state.buildingname,
        streetname: this.state.streetname,
        suburb: this.state.suburb,
        postcode: this.state.postcode,
        state: this.state.state,
        agent: this.state.agent,
        agency: this.state.agency,
        lessee: this.state.lessee,
        lessor: this.state.lessor,
        leasetype: this.state.leasetype,
      });
      this.setState({ leases });
    } catch (error) {
      this.setState({ isLoading: false });
      alert(error + ". Please refresh the page (F5) to try again.");
      return;
    }

    this.setState((state) => ({
      filter: {
        createdby: this.state.createdby,
        editedby: this.state.editedby,
        printdatefrom: this.state.printdatefrom,
        printdateto: this.state.printdateto,
        statdatefrom: this.state.statdatefrom,
        statdateto: this.state.statdateto,
        rentpsqmfrom: this.state.rentpsqmfrom,
        rentpsqmto: this.state.rentpsqmto,
        rentpannumfrom: this.state.rentpannumfrom,
        rentpannumto: this.state.rentpannumto,
        broadspace: this.state.broadspace,
        spaceuse: this.state.spaceuse,
        titlebasis: this.state.titlebasis,
        leasemethod: this.state.leasemethod,
        buildingname: this.state.buildingname,
        streetname: this.state.streetname,
        suburb: this.state.suburb,
        postcode: this.state.postcode,
        state: this.state.state,
        agent: this.state.agent,
        agency: this.state.agency,
        lessee: this.state.lessee,
        lessor: this.state.lessor,
        leasetype: this.state.leasetype,
      },
      search_count: ++this.state.search_count,
    }));

    this.setState({ isLoading: false });
  }

  async clearFilters() {
    console.log("clearFilters");
    this.setState({
      createdby: "",
      editedby: "",
      printdatefrom: null,
      printdateto: null,
      statdatefrom: null,
      statdateto: null,
      rentpsqmfrom: "",
      rentpsqmto: "",
      rentpannumfrom: "",
      rentpannumto: "",
      leasemethod: "",
      buildingname: "",
      streetname: "",
      suburb: "",
      postcode: "",
      agent: "",
      agency: "",
      lessee: "",
      lessor: "",
      leasetype: null,
      broadspace: null,
      spaceuse: null,
      titlebasis: null,
      salesmethod: null,
      selectedState: null,
      selectedSpaceUseCategories: null,
      selectedBroadSpaceUseCategories: null,
      selectedTitleBasisCategories: null,
      selectedSaleMethodCategories: null,
      filter: {
        user: this.props.user,
        screen: "leases",
      },
    });
  }

  async exportRecords(event) {
    this.setState({ isLoading: true });
    const trigger = event.target.name;
    let leasesExport = {};
    if (trigger === "PIMS") {
      if (!this.state.printdatefrom || !this.state.printdatefrom) {
        alert("You must enter print date from and to before running an export");
        this.setState({ isLoading: false });
        return;
      }

      if (!this.state.state) {
        alert("You must select a state before running an export");
        this.setState({ isLoading: false });
        return;
      }
    }
    if (trigger === "PIMS") {
      leasesExport = await this.getLeasesExport({
        createdby: this.state.createdby,
        editedby: this.state.editedby,
        printdatefrom: this.state.printdatefrom !== null ? Moment(this.state.printdatefrom).local().format() : "",
        printdateto: this.state.printdateto !== null ? Moment(this.state.printdateto).local().format() : "",
        statdatefrom: this.state.statdatefrom !== null ? Moment(this.state.statdatefrom).local().format() : "",
        statdateto: this.state.statdateto !== null ? Moment(this.state.statdateto).local().format() : "",
        rentpsqmfrom: this.state.rentpsqmfrom,
        rentpsqmto: this.state.rentpsqmto,
        rentpannumfrom: this.state.rentpannumfrom,
        rentpannumto: this.state.rentpannumto,
        broadspace: this.state.broadspace,
        spaceuse: this.state.spaceuse,
        titlebasis: this.state.titlebasis,
        leasemethod: this.state.leasemethod,
        buildingname: this.state.buildingname,
        streetname: this.state.streetname,
        suburb: this.state.suburb,
        postcode: this.state.postcode,
        state: this.state.state,
        agent: this.state.agent,
        agency: this.state.agency,
        lessee: this.state.lessee,
        lessor: this.state.lessor,
        leasetype: this.state.leasetype,
      });
    } else {
      leasesExport = await this.getLeasesClientExport({
        createdby: this.state.createdby,
        editedby: this.state.editedby,
        printdatefrom: this.state.printdatefrom !== null ? Moment(this.state.printdatefrom).local().format() : "",
        printdateto: this.state.printdateto !== null ? Moment(this.state.printdateto).local().format() : "",
        statdatefrom: this.state.statdatefrom !== null ? Moment(this.state.statdatefrom).local().format() : "",
        statdateto: this.state.statdateto !== null ? Moment(this.state.statdateto).local().format() : "",
        rentpsqmfrom: this.state.rentpsqmfrom,
        rentpsqmto: this.state.rentpsqmto,
        rentpannumfrom: this.state.rentpannumfrom,
        rentpannumto: this.state.rentpannumto,
        broadspace: this.state.broadspace,
        spaceuse: this.state.spaceuse,
        titlebasis: this.state.titlebasis,
        leasemethod: this.state.leasemethod,
        buildingname: this.state.buildingname,
        streetname: this.state.streetname,
        suburb: this.state.suburb,
        postcode: this.state.postcode,
        state: this.state.state,
        agent: this.state.agent,
        agency: this.state.agency,
        lessee: this.state.lessee,
        lessor: this.state.lessor,
        leasetype: this.state.leasetype,
      });
    }

    // console.log("Lease export :"+ leasesExport);
    // if(!leasesExport){
    //     alert("No records to export");
    //     this.setState({ isLoading: false });
    //     return
    // }

    this.setState({ leasesExport });
    var today = new Date(this.state.printdateto);
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yy = today.getFullYear();
    var stateSuffix = "";
    switch (this.state.state) {
      case "ACT":
        stateSuffix = "a";
        break;
      case "NT":
        stateSuffix = "d";
        break;
      case "NSW":
        stateSuffix = "n";
        break;
      case "QLD":
        stateSuffix = "q";
        break;
      case "SA":
        stateSuffix = "s";
        break;
      case "TAS":
        stateSuffix = "t";
        break;
      case "VIC":
        stateSuffix = "v";
        break;
      case "WA":
        stateSuffix = "w";
        break;
      default:
        stateSuffix = "";
        break;
    }
    let fileName = "";
    if (trigger === "PIMS") {
      fileName = "l" + yy.toString().substring(2, 4) + ("0" + mm).slice(-2) + ("0" + dd).slice(-2) + stateSuffix + ".pim";
    } else {
      var clientSuffix = "";
      switch (this.state.selectedClientExport.value) {
        case "NAB":
          clientSuffix = "valex";
          break;
        case "CBRE":
          clientSuffix = "cbre";
          break;
        case "CL":
          clientSuffix = "cl";
          break;
        case "GAP":
          clientSuffix = "gapmaps";
          break;
        case "ONE":
          clientSuffix = "onemap";
          break;
        default:
          clientSuffix = "";
          break;
      }
      fileName = "l" + yy.toString().substring(2, 4) + ("0" + mm).slice(-2) + ("0" + dd).slice(-2) + clientSuffix + ".csv";
    }
    var csvFile = "";
    if (trigger === "PIMS") {
      csvFile = leasesExport[0]["results"]
        .map((r) => {
          return Object.values(r)
            .map((x) => {
              if (x === null) {
                return "";
              } else if (typeof x === "number") {
                return x;
              } else {
                return '"' + x.replace("\r", "").replace("\n", "") + '"';
              }
            })
            .join(",");
        })
        .join("\r\n");
    } else {
      switch (this.state.selectedClientExport.value) {
        case "NAB":
          csvFile = leasesExport[0]["results"]
            .filter((r) => r.is_sold === true && r.price > 0)
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\r\n");
          break;
        case "CBRE":
          csvFile =
            Object.keys(leasesExport[0]["results"][0])
              .map((r, i) => {
                return this.state.cbreHeaderRow[i];
              })
              .join(",") + "\r\n"; //
          csvFile =
            csvFile +
            leasesExport[0]["results"]
              .map((r) => {
                return Object.values(r)
                  .map((x) => {
                    if (x === null) {
                      return "";
                    } else if (typeof x === "number") {
                      return x;
                    } else {
                      return '"' + (x || "") + '"';
                    }
                  })
                  .join(",");
              })
              .join("\r\n");
          break;
        case "CL":
          csvFile = leasesExport[0]["results"]
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\r\n");
          break;
        case "GAP":
          csvFile = leasesExport[0]["results"]
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\r\n");
          break;
        case "ONE":
          csvFile = leasesExport[0]["results"]
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\r\n");
          break;
        default:
          csvFile = leasesExport[0]["results"]
            .map((r) => {
              return Object.values(r).join(",");
            })
            .join("\n");
          break;
      }
    }

    var blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, fileName);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    this.setState({ isLoading: false });
  }

  renderSLMLeases() {
    const formatter = new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    // const numberFormatter = new Intl.NumberFormat("en-AU", {
    //   style: "decimal",
    //   minimumFractionDigits: 0,
    //   maximumFractionDigits: 0,
    // });

    return (
      <div>
        {this.state.isLoading && (
          <div className="outer-div">
            <div className="sweet-loading inner-div">
              <PacmanLoader
                css="display: block;
                            margin: 0 auto;
                             border-color: red"
                sizeUnit={"px"}
                size={20}
                color={"#e03c31"}
                loading={this.state.isLoading}
              />
            </div>
          </div>
        )}
        {!this.state.isLoading && (
          <Container fluid>
            <Row>
              <Col sm={12} md={12} lg={12}>
                <p>
                  <b>SLM Leases</b>
                </p>
              </Col>
            </Row>
            <Row>
              <Col md={2} lg={2}>
                <Form onSubmit={this.handleSubmit}>
                  <Row>
                    <Col>
                      <Button type="submit" size="sm" id="submit">
                        Search
                      </Button>
                    </Col>
                    <Col>
                      <Button type="button" size="sm" onClick={this.clearFilters}>
                        Clear Filters
                      </Button>
                    </Col>
                  </Row>
                  <hr />

                  <br />
                  <Form.Row>
                    <Col>
                      <Form.Group controlId="leasetype">
                        <Form.Check inline checked={this.state.leasetype === "Leased"} type="radio" label="Leased" value="Leased" onChange={this.handleChange} />
                        <Form.Check inline checked={this.state.leasetype === "For Lease"} type="radio" label="For Lease" value="For Lease" onChange={this.handleChange} />
                        <Form.Check inline checked={this.state.leasetype === "Both"} type="radio" label="Both" value="Both" onChange={this.handleChange} />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col>
                      <Form.Group controlId="createdby">
                        <Form.Control type="input" value={this.state.createdby} onChange={this.handleChange} placeholder="Created By starting" />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group controlId="editedby">
                        <Form.Control type="input" value={this.state.editedby} onChange={this.handleChange} placeholder="Last Edited By starting" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Print Date</Col>
                    <Col lg={4}>
                      <Form.Group controlId="printdatefrom">
                        <DatePicker
                          selected={this.state.printdatefrom !== null ? new Date(this.state.printdatefrom) : null}
                          onChange={(e) => this.handleDateChange(e, "printdatefrom")}
                          //   onBlur={this.handleBlur}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          isClearable={true}
                          placeholderText="From"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="printdateto">
                        <DatePicker
                          selected={this.state.printdateto !== null ? new Date(this.state.printdateto) : null}
                          onChange={(e) => this.handleDateChange(e, "printdateto")}
                          //   onBlur={this.handleBlur}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          isClearable={true}
                          placeholderText="To"
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Stat Date</Col>
                    <Col lg={4}>
                      <Form.Group controlId="statdatefrom">
                        <DatePicker
                          selected={this.state.statdatefrom !== null ? new Date(this.state.statdatefrom) : null}
                          onChange={(e) => this.handleDateChange(e, "statdatefrom")}
                          //   onBlur={this.handleBlur}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          isClearable={true}
                          placeholderText="From"
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="statdateto">
                        <DatePicker
                          selected={this.state.statdateto !== null ? new Date(this.state.statdateto) : null}
                          onChange={(e) => this.handleDateChange(e, "statdateto")}
                          //   onBlur={this.handleBlur}
                          dateFormat="dd/MM/yyyy"
                          className="form-control"
                          isClearable={true}
                          placeholderText="To"
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Rent per SQM</Col>
                    <Col lg={4}>
                      <Form.Group controlId="rentpsqmfrom">
                        <Form.Control type="input" value={formatter.format(this.state.rentpsqmfrom)} onChange={this.handleNumberChange} placeholder="From" />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="rentpsqmto">
                        <Form.Control type="input" value={formatter.format(this.state.rentpsqmto)} onChange={this.handleNumberChange} placeholder="To" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col lg={4}>Rent Per Annum</Col>
                    <Col lg={4}>
                      <Form.Group controlId="rentpannumfrom">
                        <Form.Control type="input" value={formatter.format(this.state.rentpannumfrom)} onChange={this.handleNumberChange} placeholder="From" />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="rentpannumto">
                        <Form.Control type="input" value={formatter.format(this.state.rentpannumto)} onChange={this.handleNumberChange} placeholder="To" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="broadspaceuse">
                        <Select
                          value={this.state.selectedBroadSpaceUseCategories}
                          onChange={this.handleBroadSpaceUseChange}
                          options={this.props.broadspaceusecategoryOptions.filter((a) => {
                            if (a.value === this.state.broadspace || this.state.broadspace === null) {
                              return true;
                            } else {
                              return false;
                            }
                          })}
                          isClearable
                          placeholder="Broad Use"
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="spaceuse">
                        <Select
                          value={this.state.selectedSpaceUseCategories}
                          onChange={this.handleSpaceUseChange}
                          options={this.props.spaceusecategoryOptions.filter((a) => {
                            if (a.supplementary_details.broad_space_use_id === this.state.broadspace || this.state.broadspace === null) {
                              return true;
                            } else {
                              return false;
                            }
                          })}
                          isClearable
                          //isDisabled={!this.state.broad_space_use_id?true:false}
                          placeholder="Space Use"
                        />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="leasemethod">
                        <Select value={this.state.selectedLeaseMethodCategories} onChange={this.selectedLeaseMethodCategories} options={this.props.leasemethodcategoryOptions} placeholder="Lease Method" isClearable />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="buildingname">
                        <Form.Control type="input" value={this.state.buildingname} onChange={this.handleChange} placeholder="Building Name containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="streetname">
                        <Form.Control type="input" value={this.state.streetname} onChange={this.handleChange} placeholder="Street Name starting" />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="streetext">
                        <Form.Control type="input" value={this.state.streetext} onChange={this.handleChange} placeholder="Street Ext" />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col>
                      <Form.Group controlId="suburb">
                        <Form.Control type="input" value={this.state.suburb} onChange={this.handleChange} placeholder="Suburb starting" />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col>
                      <Form.Group controlId="state">
                        <Select value={this.state.selectedState} onChange={this.handleStateChange} options={this.state.stateOptions} onInputChange={this.handleInputChange} onBlur={this.handleBlur} placeholder="Select a state" isClearable />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group controlId="postcode">
                        <Form.Control type="input" value={this.state.postcode} onChange={this.handleChange} placeholder="Postcode" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="agent">
                        <Form.Control type="input" value={this.state.agent} onChange={this.handleChange} placeholder="Agent containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="agency">
                        <Form.Control type="input" value={this.state.agency} onChange={this.handleChange} placeholder="Agency containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="lessee">
                        <Form.Control type="input" value={this.state.lessee} onChange={this.handleChange} placeholder="Lessee containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>

                  <Form.Row>
                    <Col>
                      <Form.Group controlId="lessor">
                        <Form.Control type="input" value={this.state.lessor} onChange={this.handleChange} placeholder="Lessor containing" />
                      </Form.Group>
                    </Col>
                  </Form.Row>
                  <Row>
                    <Col>
                      <Button type="button" size="sm" name="PIMS" onClick={this.exportRecords}>
                        Export PIMS
                      </Button>
                    </Col>
                  </Row>
                  {/* <Form.Row>
                            <Col>
                                <Select
                                    value={this.state.selectedClientExport}
                                    onChange={this.handleClientExportChange}
                                    options={this.state.clientExports}
                              
                                    onBlur={this.handleBlur}
                                    placeholder="Client"
                                    
                                /></Col>
                                <Col><Button type="button" size="sm" name="CLIENT" onClick={this.exportRecords} >Export Client Extract</Button></Col>
                                
                            </Form.Row>*/}
                </Form>
              </Col>
              <Col sm={10} md={10} lg={10}>
                <Row>
                  <Col sm={12} md={12} lg={12}>
                    <SLMLeaseList filter={this.state.filter} isAuthenticated={this.props.isAuthenticated} isLoading={this.state.isLoading} data={this.state.leases} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        )}{" "}
      </div>
    );
  }
  render() {
    return <div className="SLMLeaseSearch">{this.props.isAuthenticated ? this.renderSLMLeases() : console.log("error)")}</div>;
  }
}
